import { TagTypeEnum } from "../enums/tag-type.enum";

export class TagDTO {
  id: number;
  name: string;
  type?: TagTypeEnum;
  constructor(init?: TagDTO) {
    Object.assign(this, init);
  }
}
